import { render } from "./MenuItem.vue?vue&type=template&id=e236ecd6"
import script from "./MenuItem.vue?vue&type=script&lang=js"
export * from "./MenuItem.vue?vue&type=script&lang=js"

import exportComponent from "/Users/molinam/gitlab/techbio2025-vue-app/vue-mobile-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__